module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-7.cf1120f6.mp3";